import { memo, useCallback } from 'react';
import { RotateCcw } from 'lucide-react';
import { useWorkflowStore } from '../../store/workflowStore';
import { toast } from 'sonner';

const NodeResetButton = memo(({ nodeId, hasOutput }) => {
  const rerunFromNode = useWorkflowStore(s => s.rerunFromNode);
  const isRunningWorkflow = useWorkflowStore(s => s.isRunningWorkflow);

  const handleReset = useCallback(async (e) => {
    e.stopPropagation();
    const result = await rerunFromNode(nodeId);
    if (result?.cancelled) return;
    if (result?.error) {
      toast.error(result.error, { duration: 2500, position: 'bottom-right' });
    } else {
      toast.info(`Regenerando ${result?.total || 1} nodo(s)...`, { duration: 2000, position: 'bottom-right' });
    }
  }, [nodeId, rerunFromNode]);

  if (!hasOutput) return null;

  return (
    <button
      className="node-reset-btn"
      onClick={handleReset}
      disabled={isRunningWorkflow}
      title="Regenerar nodo y propagación downstream"
      data-testid={`reset-node-${nodeId}`}
    >
      <RotateCcw size={12} />
    </button>
  );
});

NodeResetButton.displayName = 'NodeResetButton';
export default NodeResetButton;
